// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import TTObjectModel from '../../model/tt-object-model';
import TTObjectDTO from '../dto/tt-object-dto';
import dtoSchema from '../schemas/tt-object-schema';

export default abstract class TTObjectModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<TTObjectDTO>) {
    super();
    if (data) {
      this.comment = data.comment ?? undefined;
      this.ttComment = data.ttComment ?? undefined;
      this.isTT = data.isTT;
    }
  }
  /**
  */
  comment?: string;
  /**
  */
  ttComment?: string;
  /**
  */
  isTT?: boolean;

  static toModel(dto: DeepPartial<TTObjectDTO>): TTObjectModel;
  static toModel(dto: DeepPartial<TTObjectDTO> | undefined | null): TTObjectModel | undefined;
  static toModel(dto: DeepPartial<TTObjectDTO> | undefined | null): TTObjectModel | undefined {
    return dto ? new TTObjectModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<TTObjectModel> | TTObjectModel): TTObjectDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      comment: unwrapped.comment,
      ttComment: unwrapped.ttComment,
      isTT: unwrapped.isTT,
    } as TTObjectDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for TTObjectModel, can not map to TTObjectDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
